import { isEQUATORIALEnv } from "../utils/EnvUtils";

export const getCAMPUS = () =>
  isEQUATORIALEnv ? "SMARTIKS_LITECAMPUS" : process.env.REACT_APP_CAMPUS;
